import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  return localStorage.getItem("userTokenTime") ? children : <Navigate to="/signin" />;
};

export default PrivateRoute;